module.exports = __webpack_public_path__ + "img/9788997381524.6dbb216c.jpg";